<ng-container *transloco="let t">
	@if (false) {
		<eventlyte-text-field
			formKey="cardNumber"
			[formGroup]="formGroup"
			[label]="t('fields.cardNumber.label')"
				[editing]="true"
			[value]="getRecordValue(record, 'cardNumber')"
			(valueChange)="setRecordValue(record, 'cardNumber', $event)" />

	}

	<div class="registration-page-container">
		<eventlyte-registration-stepper-progress
			class="is-hidden-print"
			[currentStep]="AppRoutePaths.RegistrationConfirmation"
			[steps]="getSteps()"
			[maxStepReached]="maxStepReached" />

		<p class="title is-4">{{ t('content.steps.confirmation') }}</p>

		<div class="content">
			<p>
				{{ t('content.pages.registrationConfirmation.instructions1') }}
				<a href="https://www.aipluspower.com/" target="_blank"
					>https://www.aipluspower.com/</a
				>
			</p>
			<p>{{ t('content.pages.registrationConfirmation.instructions2') }}</p>
			<p>
				{{ t('content.pages.registrationConfirmation.instructions3') }}
			</p>
		</div>

		<section class="section m-0 p-0">
			@if (!isLoading()) {
				<app-registration-confirmation-badge
					[title]="t('content.pages.registrationConfirmation.mainCardHeader')"
					[record]="record()"
					[cardNumberLabel]="t('fields.cardNumber.label')"
					[fullNameLabel]="t('fields.fullName.label')"
					[countryLabel]="t('fields.country.label')"
					[showCountry]="true"
					[barcodeWidth]="140" />
			}
		</section>

		<!-- Date & Time Section -->
		<div class="content mb-0 mt-5">
			<h2 class="title is-4">
				{{ t('content.pages.landingPage.dateTime.heading') }}
			</h2>
			<div>
				<fa-icon [icon]="icons.faCalendar" />
				{{ t('content.pages.landingPage.dateTime.day1') }}
			</div>
			<div>
				<fa-icon [icon]="icons.faCalendar" />
				{{ t('content.pages.landingPage.dateTime.day2') }}
			</div>
		</div>

		<hr class="is-hidden-print mb-0" />

		<!-- Venue Section -->
		<div class="content mb-0 mt-3">
			<h2 class="title is-4">
				{{ t('content.pages.landingPage.venue.heading') }}
			</h2>
			<p>
				<fa-icon [icon]="icons.faMapPin" />
				{{ t('content.pages.landingPage.venue.location') }}
			</p>
		</div>

		<hr class="is-hidden-print" />

		<!-- Admission Policy Section -->
		<div class="notification is-info is-dark">
			<h2 class="title is-5 mb-1">
				{{ t('content.pages.landingPage.admission.heading') }}
			</h2>
			<p>- {{ t('content.pages.landingPage.admission.policy1') }}</p>
			<p>- {{ t('content.pages.landingPage.admission.policy2') }}</p>
			<p>- {{ t('content.pages.landingPage.admission.policy3') }}</p>
		</div>

		<div class="mt-auto is-hidden-print">
			<eventlyte-registration-stepper-controls
				[currentStep]="AppRoutePaths.RegistrationConfirmation"
				[steps]="getSteps()"
				(startAgain)="startAgain()" />
		</div>
	</div>
</ng-container>
